module.exports = __webpack_public_path__ + "img/chargingpoint-fastcharger-realized.f2221612.png";